 import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl,Validators} from '@angular/forms';
import {PasswordService} from '../../Services/password.service';
import { Router } from '@angular/router';
import {AppSettings} from '../../app-settings';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css',
  '../forgot-password/forgot-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  constructor(private changepassword:PasswordService, private router:Router) { }
  ngOnInit() {}
  isError : Boolean = true;
  isNotsameError : Boolean = false;
  errorMsg = "*Passwords do not match";
  updateSuccess : boolean = false;

  changePassFrom = new FormGroup({
		pwd:new FormControl(null,Validators.required),
		cnfpwd:new FormControl(null,[Validators.required])
	});

  onChangePassword()
  {

  	 if(this.changePassFrom.value.pwd != this.changePassFrom.value.cnfpwd)
     {
        this.isNotsameError  = true;
     }
     else
      {
         this.isNotsameError  = false;
        this.changepassword.changePassword(AppSettings.restApiUrl+"/api/user/updatePassword",{"password":this.changePassFrom.value.pwd,"passwordAgain":this.changePassFrom.value.cnfpwd}).subscribe(data=>{

             this.updateSuccess = true;
          },
          resuserEmail =>{
      
        this.errorMsg ="Password could not be reset  .Please  contact support@e-gmat.com";
        this.isNotsameError = true;  
    })
      }
  }

}
